import { useEffect, useRef, useState } from 'react'

const MARQUEE_SPEED_PX_PER_SEC = 40

const MarqueeText = ({ text, className = '' }) => {
  const containerRef = useRef(null)
  const [overflow, setOverflow] = useState(false)
  const [scrollDistance, setScrollDistance] = useState(0)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return undefined

    const measure = () => {
      const inner = container.querySelector('[data-marquee-inner]')
      if (!inner) return

      const distance = inner.scrollWidth - container.clientWidth
      setOverflow(distance > 2)
      setScrollDistance(distance)
    }

    measure()
    window.addEventListener('resize', measure)

    return () => window.removeEventListener('resize', measure)
  }, [text])

  const marqueeDuration =
    scrollDistance > 0 ? `${scrollDistance / MARQUEE_SPEED_PX_PER_SEC}s` : '2.5s'

  return (
    <span
      ref={containerRef}
      className={['block min-w-0 overflow-hidden', className].join(' ')}
      title={overflow ? text : undefined}
    >
      <span
        data-marquee-inner
        className={[
          overflow ? 'site-marquee-text inline-block whitespace-nowrap' : 'block truncate',
        ].join(' ')}
        style={
          overflow
            ? {
                '--marquee-distance': `-${scrollDistance}px`,
                '--marquee-duration': marqueeDuration,
              }
            : undefined
        }
      >
        {text}
      </span>
    </span>
  )
}

export default MarqueeText
